import { User } from 'oidc-client-ts';
import { Modalidade, PerfilAluno, PerfilEducador, Situacao, Usuario, UsuarioAura } from '../..';
import { TurmaCursada } from '../../contexts/usuario/usuario.types';
import { FixtureAlunoResult, FixtureEducadorResult, FixtureUsuario } from './usuario.types';

export const usuarioFixture: FixtureUsuario = () => {
  const mockAluno: Usuario<PerfilAluno> = {
    aura: {
      dados: {
        id: '2',
        idExterno: '4',
        nome: 'Elon Musk',
        emailUtilizado: 'elon@musk.br',
        credenciais: [],
        marca: '',
        matriculas: [
          {
            id: '1',
            idExterno: '3',
            entregas: [],
            nomeCurso: 'Introdução ao estudo do direito',
            tipoCurso: 'presencial',
            campus: 'Rio de janeiro',
            turno: 'noite',
            situacao: Situacao.ATIVO,
            calendario: 'teste',
            modalidade: null,
            periodosAnteriores: [],
            turmasCursadas: [],
          },
        ],
        config: {
          visualizouOnboarding: false,
          visualizouAvisoBDQ: false,
          visualizouAvisoLabVirtual: false,
          visualizouAvisoBibliotecaVirtual: false,
          visualizouAvisoEmpregabilidade: false,
          secaoSingular: 'SEM_BLOQUEIO',
          faseSingular: 4,
        },
        dataAtualizacao: new Date(),
      },
      perfil: 'ALUNO',
    } as UsuarioAura<PerfilAluno>,
    oidc: {
      id_token: 'g?3?x',
      access_token: 'testAcessToken',
      refresh_token: '1234564dasdhJIO0989d7x',
    } as User,
    logoff: jest.fn(),
  };
  const mockEducador: Usuario<PerfilEducador> = {
    aura: {
      dados: {
        id: '1',
        nome: 'Jeff Bezos',
        marca: '',
        cpf: '12345678909',
        curriculoLatesURL: 'https://lattes.cnpq.br/',
        calendarios: [],
        entregas: [],
        credenciais: [],
        config: {
          visualizouOnboarding: false,
          visualizouAvisoBDQ: false,
          visualizouAvisoLabVirtual: false,
          visualizouAvisoBibliotecaVirtual: false,
          visualizouAvisoEmpregabilidade: false,
        },
        dataAtualizacao: new Date(),
      },
      perfil: 'EDUCADOR',
    } as UsuarioAura<PerfilEducador>,
    oidc: {
      id_token: 'g?3?x',
      access_token: 'testAcessToken',
      refresh_token: '1234564dasdhJIO0989d7x',
    } as User,
    logoff: jest.fn(),
  };

  const aluno = (): FixtureAlunoResult => {
    const alunoMock = { ...mockAluno };

    return {
      marca: function (param) {
        alunoMock.aura.dados.marca = param;
        return this;
      },
      ead: function () {
        alunoMock.aura.dados.matriculas[0].modalidade = Modalidade.TOTAL_EAD;
        return this;
      },
      semiPresencial: function () {
        alunoMock.aura.dados.matriculas[0].modalidade = Modalidade.SEMIPRESENCIAL;
        return this;
      },
      presencial: function () {
        alunoMock.aura.dados.matriculas[0].modalidade = Modalidade.PRESENCIAL;
        return this;
      },
      periodosAnteriores: function (periodos: string[]) {
        alunoMock.aura.dados.matriculas[0].periodosAnteriores = periodos;
        return this;
      },
      turmasCursadas: function (turmas: TurmaCursada[]) {
        alunoMock.aura.dados.matriculas[0].turmasCursadas = turmas;
        return this;
      },
      get: function () {
        return alunoMock;
      },
    };
  };

  const educador = (): FixtureEducadorResult => {
    const educadorMock = { ...mockEducador };

    return {
      marca: function (param) {
        educadorMock.aura.dados.marca = param;
        return this;
      },
      get: function () {
        return educadorMock;
      },
    };
  };

  return { aluno, educador };
};
